module.exports = __webpack_public_path__ + "media/src/images/dialog-close-9c81fd77b0769596d6824623edc33785.png";